import Vue from "vue"

Vue.filter("numberFormat", function (str) {
    if (str) {
        return str.toLocaleString();
    } else {
        return str;
    }
});

Vue.filter("fileSize", size => {
    if (size > 1000 * 1000 * 1000) {
        return (size / 1000 / 1000 / 1000).toFixed(2).toLocaleString() + 'GB'
    } else if (size > 1000 * 1000) {
        return Math.round((size * 100 / 1000 / 1000) / 100).toLocaleString() + 'MB'
    } else if (size > 1000) {
        return Math.round(size / 1000).toLocaleString() + 'KB'
    } else {
        return Math.round(size).toLocaleString() + 'Byte'
    }
});

Vue.filter("getFileExtension", filename => filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase());
Vue.filter("contentFormat", function (content) {
    if (content) {
        return content.replace(/(?:\r\n|\r|\n)/g, '<br />')
    } else {
        return content
    }
})



// WEBPACK FOOTER //
// ./src/filters/index.js